import { formatMinorAmount } from "@/constants/billingCatalog";

export function formatCatalogAmount(amountMinor, currency) {
  const code = String(currency).toUpperCase();
  const digits = Number(amountMinor) % 100 === 0 ? 0 : 2;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: code,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(amountMinor) / 100);
}

export function fromPriceLine(amountMinor, currency) {
  return `From ${formatMinorAmount(amountMinor, currency)} after trial · Cancel anytime`;
}

export function catalogEntryOffer(items) {
  if (!items?.length) return null;
  return [...items].sort(
    (a, b) => a.sort_order - b.sort_order || a.amount_minor - b.amount_minor
  )[0];
}

export function minimumCatalogOffer(items) {
  if (!items?.length) return null;
  return [...items].sort(
    (a, b) =>
      a.amount_minor - b.amount_minor ||
      a.sort_order - b.sort_order ||
      String(a.tariff_id ?? "").localeCompare(String(b.tariff_id ?? ""))
  )[0];
}

export function roofingMicroLine(entryOffer) {
  if (!entryOffer) return "No credit card · Works with your existing CRM";
  return `No credit card · ${formatCatalogAmount(entryOffer.amount_minor, entryOffer.currency)}/month after trial · Works with your existing CRM`;
}

export function plugPlayRoofingAfterTrial(entryOffer) {
  if (!entryOffer) return "Launch in 72 Hours";
  return `${formatCatalogAmount(entryOffer.amount_minor, entryOffer.currency)}/month after trial · Launch in 72 Hours`;
}

export function realEstateSubscribeLabel(entryOffer) {
  if (!entryOffer) return "Subscribe";
  return `Subscribe — ${formatMinorAmount(entryOffer.amount_minor, entryOffer.currency)}`;
}
